import axios, {AxiosRequestConfig, AxiosResponse} from 'axios'
import ApiLogsStore from "@/store/modules/ApiLogsStore";
import UserStore from "@/store/modules/UserStore";
import {CmsApiClientLocal} from "@/_global/api_clients/CmsApiClientLocal";
import { Util } from '@/_global/utils'

// fixme 本番と開発をパラメータで切り分ける。
const host: string = Util.getCmsApiHostUrl();

function makeConfig(): AxiosRequestConfig {
    return {
        withCredentials: false,
        headers: {
            // fixme フロントページで認証しているので、APIの認証はいったんパス。
            //       API側にセッションキャッシュの仕組みを作ったら切り替える
            "X-LIO-DEBUG-MODE": "1",
            "X-LIO-SESSION-ID": UserStore.user.head_code,
            "X-LIO-HEAD-ID": Util.getUrlParam("head_id"),

            // "X-LIO-SESSION-ID": UserStore.user.session_cookie,
            // "X-LIO-HEAD-ID": Util.getUrlParam("head_id"),
        },
        data: {} // ←カスタムヘッダを送るときは必須らしい
    }
}


export class CmsApiClientProd {

    public static async getHealth() {
        const url = host + "/";
        return axios.get(url);
    }

    public static async getMenus() {
        const url = host + "/menus";
        const response = await axios.get(url, makeConfig());
        ApiLogsStore.add(response);
        return response.data || [];
    }

    public static async createMenu(menu: CMS.Menu) {
        const url = host + "/menus";
        const body = menu;
        const response = await axios.post(url, body, makeConfig())
        ApiLogsStore.add(response);
    }

    public static async editMenu(menu: CMS.Menu) {
        const url = host + "/menus/" + menu.id;
        const body = menu;
        const response = await axios.put(url, body, makeConfig());
        ApiLogsStore.add(response);
    }

    public static async sortMenus(order: number[]) {
        const url = host + "/menu_orders";
        const body = JSON.stringify(order);
        const response = await axios.post(url, body, makeConfig());
        ApiLogsStore.add(response);
    }

    public static async deleteMenu(menu: CMS.Menu) {
        const url = host + "/menus/" + menu.id;
        const response = await axios.delete(url, makeConfig());
        ApiLogsStore.add(response);
    }

    public static async createMenuStore(menu: CMS.Menu, storeId: number) {
        const url = host + "/menus/" + menu.id.toString() + "/stores/" + storeId.toString();
        const body = {};
        const response = await axios.post(url, body, makeConfig())
        ApiLogsStore.add(response);
    }

    public static async deleteMenuStore(menu: CMS.Menu, storeId: number) {
        const url = host + "/menus/" + menu.id.toString() + "/stores/" + storeId.toString();
        const response = await axios.delete(url, makeConfig());
        ApiLogsStore.add(response);
    }

    public static async updateMenuStores(menu: CMS.Menu) {
        const url = host + "/menus/" + menu.id.toString() + "/stores";
        const body = JSON.stringify(menu.store_ids);
        const response = await axios.put(url, body, makeConfig());
        ApiLogsStore.add(response);
    }

    public static async getSchedules(menuId: number) {
        const url = host + "/menus/" + menuId.toString() + "/schedules";
        const response = await axios.get(url, makeConfig());
        ApiLogsStore.add(response);
        return response.data || [];
    }

    public static async createSchedule(schedule: CMS.Schedule) {
        const url = host + "/menus/" + schedule.menu_id.toString() + "/schedules";
        const body = JSON.stringify(schedule);
        const response = await axios.post(url, body, makeConfig());
        ApiLogsStore.add(response);
    }

    public static async editSchedule(schedule: CMS.Schedule) {
        const url = host + "/menus/" + schedule.menu_id.toString() + "/schedules/" + (schedule.id as any).toString();
        const body = JSON.stringify(schedule);
        const response = await axios.put(url, body, makeConfig());
        ApiLogsStore.add(response);
    }

    public static async deleteSchedule(schedule: CMS.Schedule) {
        const url = host + "/menus/" + schedule.menu_id.toString() + "/schedules/" + (schedule.id as any).toString();
        const response = await axios.delete(url, makeConfig());
        ApiLogsStore.add(response);
    }

    public static async getImages() {
        const url = host + "/images";
        const response = await axios.get(url, makeConfig());
        ApiLogsStore.add(response);
        return response.data || [];
    }

    public static async createImage(image: CMS.Image) {
        const url = host + "/images";
        const body = JSON.stringify(image);
        const response = await axios.post(url, body, makeConfig());
        ApiLogsStore.add(response);
    }

    public static async editImage(image: CMS.Image) {
        const url = host + "/images/" + image.id;
        const body = JSON.stringify(image);
        const response = await axios.put(url, body, makeConfig());
        ApiLogsStore.add(response);
    }

    public static async deleteImage(image: CMS.Image) {
        const url = host + "/images/" + image.id;
        const response = await axios.delete(url, makeConfig());
        ApiLogsStore.add(response);
    }

    public static async getCategories(menuId: number) {
        const url = host + "/menus/" + menuId.toString() + "/categories";
        const response = await axios.get(url, makeConfig());
        ApiLogsStore.add(response);
        return response.data || [];
    }

    public static async createCategory(category: CMS.Category) {
        const url = host + "/menus/" + category.menu_id.toString() + "/categories";
        const body = JSON.stringify(category);
        const response = await axios.post(url, body, makeConfig());
        ApiLogsStore.add(response);
    }

    public static async editCategory(category: CMS.Category) {
        const url = host + "/menus/" + category.menu_id.toString() + "/categories/" + category.id.toString();
        const body = JSON.stringify(category);
        const response = await axios.put(url, body, makeConfig());
        ApiLogsStore.add(response);
    }

    public static async deleteCategory(category: CMS.Category) {
        const url = host + "/menus/" + category.menu_id.toString() + "/categories/" + category.id.toString();
        const response = await axios.delete(url, makeConfig());
        ApiLogsStore.add(response);
    }

    public static async sortCategory(menuId: number, order: number[]) {
        const url = host + "/menus/" + menuId + "/category_orders";
        const body = JSON.stringify(order);
        const response = await axios.post(url, body, makeConfig());
        ApiLogsStore.add(response);
    }

    public static async getCategoryItems(menuId: number) {
        const url = host + "/menus/" + menuId.toString() + "/categories/items";
        const response = await axios.get(url, makeConfig());
        ApiLogsStore.add(response);
        return response.data || [];
    }

    public static async setCategoryItems(menuId: number, categoryId: number, categoryItems: CMS.CategoryItem[]) {
        const url = host + "/menus/" + menuId.toString() + "/categories/" + categoryId.toString() + "/items";
        const body = JSON.stringify(categoryItems);
        const response = await axios.put(url, body, makeConfig());
        ApiLogsStore.add(response);
    }

    public static async getThemes() {
        // const url = host + "/themes";
        // return axios.get(url, makeConfig());

        // fixme テーマ増えたらDBからとるようにする
        return CmsApiClientLocal.getThemes()
    }


    public static async getThemeVariable(themeId: number, menuId: number) {
        const url = host + "/themes/" + themeId + "/menus/" + menuId + "/variable";
        const response = await axios.get(url, makeConfig());
        ApiLogsStore.add(response);

        if (response.data) {
            // テーマ設定値のJSONが文字列で返ってくるのでパースして返す（JSONで返すまでがAPIなのでここに書く） APIが対応したら消す
            const themeVariable: CMS.ThemeVariable = response.data;
            themeVariable.value = JSON.parse(themeVariable.value as any);
            return themeVariable;
        } else {
            return {};
        }
    }

    public static async setThemeVariable(themeVariable: CMS.ThemeVariable) {
        const url = host + "/themes/" + themeVariable.theme_id + "/menus/" + themeVariable.menu_id + "/variable";
        const body = JSON.stringify(themeVariable.value);
        const response = await axios.post(url, body, makeConfig());
        ApiLogsStore.add(response);
    }

    public static async getThemeCategoryVariables(themeId: number, menuId: number) {
        const url = host + "/themes/" + themeId + "/menus/" + menuId + "/categories/variable";
        const response = await axios.get(url, makeConfig());
        ApiLogsStore.add(response);

        if (response.data) {
            // テーマ設定値のJSONが文字列で返ってくるのでパースして返す（JSONで返すまでがAPIなのでここに書く） APIが対応したら消す
            const themeCategoryVariables: CMS.ThemeCategoryVariable[] = response.data;
            for (let i = 0; i < themeCategoryVariables.length; i++) {
                themeCategoryVariables[i].value = JSON.parse(themeCategoryVariables[i].value);
            }
            return themeCategoryVariables;
        } else {
            return [];
        }
    }

    public static async setThemeCategoryVariable(themeCategoryVariable: CMS.ThemeCategoryVariable) {
        const url = host + "/themes/" + themeCategoryVariable.theme_id + "/categories/" + themeCategoryVariable.category_id + "/variable";
        const body = JSON.stringify(themeCategoryVariable.value);
        const response = await axios.post(url, body, makeConfig());
        ApiLogsStore.add(response);
    }

    public static async getThemeItemVariables(themeId: number) {
        const url = host + "/themes/" + themeId + "/items/variable";
        const response = await axios.get(url, makeConfig());
        ApiLogsStore.add(response);

        if (response.data) {
            // テーマ設定値のJSONが文字列で返ってくるのでパースして返す（JSONで返すまでがAPIなのでここに書く） APIが対応したら消す
            const themeItemVariables: CMS.ThemeItemVariable[] = response.data;
            for (let i = 0; i < themeItemVariables.length; i++) {
                themeItemVariables[i].value = JSON.parse(themeItemVariables[i].value);
            }
            return themeItemVariables;
        } else {
            return [];
        }
    }

    public static async setThemeItemVariable(themeItemVariable: CMS.ThemeItemVariable) {
        const url = host + "/themes/" + themeItemVariable.theme_id + "/items/" + themeItemVariable.item_id + "/variable";
        const body = JSON.stringify(themeItemVariable.value);
        const response = await axios.post(url, body, makeConfig());
        ApiLogsStore.add(response);
    }

    public static async getItems() {
        const url = host + "/items";
        const response = await axios.get(url, makeConfig());
        ApiLogsStore.add(response);
        return response.data || [];
    }

    public static async setItem(item: CMS.Item) {
        const url = host + "/items/" + item.item_id;
        const body = JSON.stringify(item);
        const response = await axios.post(url, body, makeConfig());
        ApiLogsStore.add(response);
    }

    // todo  セット対応時に実装
    public static async getSelections() {
        return [];
    }

    // todo  セット対応時に実装
    public static async setSelection(selection: CMS.Selection) {
    }

    public static async getCondimentGroups() {
        const url = host + "/condiment_groups";
        const response = await axios.get(url, makeConfig());
        ApiLogsStore.add(response);
        return response.data || [];
    }

    public static async setCondimentGroup(condimentGroup: CMS.CondimentGroup) {
        const url = host + "/condiment_groups/" + condimentGroup.condiment_group_id;
        const body = JSON.stringify(condimentGroup);
        const response = await axios.post(url, body, makeConfig());
        ApiLogsStore.add(response);
    }


    // ----- その他 ------------------------------------------------
    public static async getDeliousItemDetailList(storeId: number, periodId: number) {
        const url = host + "/delious/plu/getdetail";
        let config = makeConfig();
        config.headers["X-LIO-STORE-ID"] = storeId;
        config.headers["X-LIO-PERIOD-ID"] = periodId;
        const response = await axios.get(url, config);
        ApiLogsStore.add(response);
        return response.data || {};
    }

    // todo  APIをつくる！！！！！
    public static async uploadFile(formData: FormData) {
        const url = host + "/upload";
        const body = formData;
        let config = makeConfig();
        config.headers['Content-Type'] = 'multipart/form-data';
        const response = await axios.post(url, body, {'headers': config.headers});
        ApiLogsStore.add(response);
        return response;
    }
}

